<div class="key" class='{{direccion}}'>
    <!-- <h3 class="mat-subheading-1" style="margin-top: 12px;">Convenciones</h3> -->
    <ng-container *ngIf="data; else nivelaciones">
        <div>
            <label style="font-size:14px; align-items: center;">
                <span style="width: 20%; display: flex; align-items: center;">
                    <mat-icon [ngStyle]="{'font-size': '14px', 'line-height': '25px', 'text-align': 'right', 'width': '15px', 'margin-right': '4px', 'color': '#33CC33'}">
                        fiber_manual_record
                    </mat-icon>
                    {{(data | asistenciaCodigo: 'P')?.codigo}}:
                </span><span style="opacity:.6;width: 80%;">{{(data | asistenciaCodigo: 'P')?.detalle}}</span></label>
        </div>
        <div *ngFor="let filtro of dataFilterValues">
            <label style="font-size:14px; align-items: center;">
                <span style="width: 20%; display: flex; align-items: center;">
                    <mat-icon [ngStyle]="{'font-size': '14px', 'line-height': '25px', 'text-align': 'right', 'width': '15px', 'margin-right': '4px', 'color': filtro.indexOf('A') > -1 ? '#cc0000' : '#ff9900'}">
                        fiber_manual_record
                    </mat-icon>
                    {{(data | asistenciaCodigo: filtro)?.codigo}}:
                </span><span style="opacity:.6;width: 80%;">{{(data | asistenciaCodigo: filtro)?.detalle}}</span></label>
        </div>
        <!-- <div>
            <label>
                <mat-icon class="md-14" color="warn">warning</mat-icon>
                Ausencias consecutivas
            </label>
            <small>El alumno tiene tres o más ausencias consecutivas.</small>
        </div> -->
    </ng-container>
    <ng-template #nivelaciones>
        <ng-container *ngIf="hijo">
                <div>
                    <label>
                        <div class="basic proxima"></div>
                        Citado
                    </label>
                    <small>El alumno ha sido citado a nivelación.</small>
                </div>
        </ng-container>
        <ng-container *ngIf="completo">
            <div>
                <label>
                    <mat-icon [ngStyle]="{'font-size': '14px', 'line-height': '25px', 'text-align': 'right', 'width': '15px', 'margin-right': '4px'}">
                        check_box_outline_blank
                    </mat-icon>
                    No citado
                </label>
                <small>El alumno no ha sido citado a nivelación.</small>
            </div>
            <div>

                <label>
                    <mat-icon [ngStyle]="{'font-size': '14px', 'line-height': '25px', 'text-align': 'right', 'width': '15px', 'margin-right': '4px'}">
                        check_box
                    </mat-icon>
                    Citado
                </label>
                <small>El alumno ha sido citado a nivelación y la cita puede cancelarse.</small>
            </div>
        </ng-container>
        <ng-container *ngIf="asistencia">
            <div>
                <label>
                    <div class="basic proxima"></div>
                    Próximas
                </label>
                <small>El alumno ha sido citado a nivelación y la cita no puede cancelarse.</small>
            </div>
            <div>
                <label>
                    <div class="basic noReportada"></div>
                    Reporte pendiente
                </label>
                <small>El alumno fue citado y el profesor no ha reportado asistencia.</small>
            </div>
            <div>
                <label>
                    <div class="basic asistencia"></div>
                    Asistencias
                </label>
                <small>El alumno asistió a la nivelación.</small>
            </div>
            <div>
                <label>
                    <div class="basic retardo"></div>
                    Retardos
                </label>
                <small>El alumno llegó tarde a la nivelación.</small>
            </div>
            <div>
                <label>
                    <div class="basic ausencia"></div>
                    Ausencias
                </label>
                <small>El alumno no asistió a la nivelación.</small>
            </div>
        </ng-container>
    </ng-template>
</div>